import { render, staticRenderFns } from "./AddUsersToTasksModal.vue?vue&type=template&id=2493fefb&scoped=true&"
import script from "./AddUsersToTasksModal.vue?vue&type=script&lang=js&"
export * from "./AddUsersToTasksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493fefb",
  null
  
)

export default component.exports